
import { NotificationManager } from "react-notifications";

import apiURL from "./apiURL";
import { createRequest } from "@/components/common/helpers/RequestHelpers";
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
	PERMISSION_INVITE_USER_MODAL: "PERMISSION_INVITE_USER_MODAL",
	PERMISSION_INVITED_USER: "PERMISSION_INVITED_USER",
	// GRADE_UPDATE_CURRENT_TIMESHEET: "GRADE_UPDATE_CURRENT_TIMESHEET"
	PERMISSION_GET: "PERMISSION_GET",
	PERMISSION_SAVE: "PERMISSION_SAVE",
	PERMISSION_SAVING: "PERMISSION_SAVING",
	PERMISSION_UPDATE: "PERMISSION_UPDATE",
	PERMISSION_MY: "PERMISSION_MY",
	PERMISSION_INVITE_MANAGER_MODAL: "PERMISSION_INVITE_MANAGER_MODAL",
	PERMISSION_INVITED_MANAGER: "PERMISSION_INVITED_MANAGER",
	PERMISSION_INVITING_MANAGER: "PERMISSION_INVITING_MANAGER",
	PERMISSION_AOP_MODAL: "PERMISSION_AOP_MODAL",
};

const settingsRequest = createRequest({ 
	urlPath: "/settings",
	// local: true
});

// actions
const inviteUserModal = (status) => ({
	type: Types.PERMISSION_INVITE_USER_MODAL,
	status: status,
});

const inviteManagerModal = (status) => ({
	type: Types.PERMISSION_INVITE_MANAGER_MODAL,
	status: status,
});

const invitedManager = (response) => ({
	type: Types.PERMISSION_INVITED_MANAGER,
	payload: response,
});

const invitingManager = (status) => ({
	type: Types.PERMISSION_INVITING_MANAGER,
	status,
});

const inviteManager = (permissions) => {
	return (dispatch, getState) => {
		dispatch(invitingManager(true));
		settingsRequest({
			path: `/inviteManager`,
			method: "POST",
			body: permissions,
		})
			.then(({ data }) => {
				NotificationManager.success("Invite Sent Successfully!", "Inviting Manager");
				dispatch(invitedManager(data));
				dispatch(getPermissions());
			})
			.catch((error) => {
				console.error(error);
				dispatch(invitingManager());
				NotificationManager.error("Error Inviting Manager", "Inviting Manager");
			});
	};
};

const invitedUser = (response) => ({
	type: Types.PERMISSION_INVITED_USER,
	payload: response,
});

const inviteUser = (permissions) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/inviteUser/`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(permissions),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(invitedUser(data));
				dispatch(getPermissions());
			});
	};
};

const permissionsSaved = (response, user) => ({
	type: Types.PERMISSION_SAVE,
	payload: response,
	user,
});

const permissionsSaving = (user) => ({
	type: Types.PERMISSION_SAVING,
	user,
});

const openActionOnPermModal = (open) => ({
	type: Types.PERMISSION_AOP_MODAL,
	open,
});

const updatePOC = (user) => {
	return async (dispatch, getState) => {
		if (!user) {
			NotificationManager.error("Please select a user", "Error");
			return;
		}

		await settingsRequest({
			method: "POST",
			body: { user },
			path: "/permissions/point-of-contact",
		})
			.then(({ data }) => {
        NotificationManager.success("Point of contact updated", "Success");
				dispatch(openActionOnPermModal(false));
				dispatch(getPermissions());
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error updating point of contact", "Error");
			});
	};
};

const updateAccountOwner = (user) => {
	return async (dispatch, getState) => {
		if (!user) {
			NotificationManager.error("Please select a user", "Error");
			return;
		}

		await settingsRequest({
			method: "POST",
			body: { user },
			path: "/permissions/transfer-ownership",
		})
			.then(({ data }) => {
        NotificationManager.success("Account owner updated successfully", "Success");
				dispatch(openActionOnPermModal(false));
				dispatch(getPermissions());
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error updating point of contact", "Error");
			});
	};
};

const revokeAccess = (user) => {
	return async (dispatch, getState) => {
		if (!user) {
			NotificationManager.error("Please select a user", "Error");
			return;
		}

		await settingsRequest({
			method: "DELETE",
			body: { user },
			path: "/permissions/revoke",
		})
			.then(({ data }) => {
        NotificationManager.success("Access Revoked", "Success");
				dispatch(openActionOnPermModal(false));
				dispatch(getPermissions());
			})
			.catch((err) => {
				console.error(err);
				NotificationManager.error("Error updating point of contact", "Error");
			});
	};
};

const savePermissions = (permissions) => {
  return (dispatch, getState) => {

    dispatch(permissionsSaving(permissions.userId))

    fetch(apiURL + `/settings/permissions/` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(permissions),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(permissionsSaved(data,permissions.userId))
      // dispatch(getPermissions())
    })
  }
}

const updatePermission = ({user,permission,value}) => ({
  type: Types.PERMISSION_UPDATE,
  user,permission,value
});


const permissionsObtained = response => ({
  type: Types.PERMISSION_GET,
  payload: response
});

const getPermissions = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/settings/permissions` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(permissionsObtained(data))
    })
  }
}


const myPermissionsObtained = response => ({
  type: Types.PERMISSION_MY,
  payload: response
});

const getMyPermissions = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/settings/my/permissions` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(myPermissionsObtained(data))
    })
	.catch((err) => {
		console.error(err);
	});
  }
}

const Actions = {
  inviteUserModal,
  inviteUser,
  inviteManager,
  savePermissions,
  getPermissions,
  updatePermission,
  getMyPermissions,
  inviteManagerModal,
  openActionOnPermModal,
  updatePOC,
  revokeAccess,
  updateAccountOwner
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions